type Cell = string | number | boolean | null | undefined;

function escapeCell(v: Cell): string {
  const s = v == null ? '' : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** 將物件陣列轉成 CSV 字串（含表頭）。 */
export function toCsv(rows: Record<string, Cell>[], headers?: string[]): string {
  if (rows.length === 0) return '';
  const cols = headers ?? Object.keys(rows[0]);
  const head = cols.map(escapeCell).join(',');
  const body = rows.map((r) => cols.map((c) => escapeCell(r[c])).join(',')).join('\n');
  return `${head}\n${body}`;
}

/** 觸發瀏覽器下載 CSV（含 UTF-8 BOM，Excel 中文不亂碼）。 */
export function downloadCsv(filename: string, rows: Record<string, Cell>[], headers?: string[]): void {
  const csv = toCsv(rows, headers);
  const blob = new Blob([`﻿${csv}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
